// Українські підписи для кодів критеріїв AHP/TOPSIS. Коди критеріїв
// приходять із бекенду (ключі weights/breakdown), підпис тут потрібен лише
// для відображення -- якщо код невідомий, показуємо сам код.
export const CRITERION_LABELS = {
  // Критерії рівня 1 за статтею.
  ses: "Сесія (s)",
  dorm: "Активність у гуртожитку (g)",
  act: "Діяльність (f)",
  zone: "Віддаленість (q)",
  // Застарілі коди: лишаються лише для підпису збережених профілів ваг.
  gpa: "Середній бал успішності",
  ach: "Досягнення",
  vio: "Порушення",
};

export function criterionLabel(code) {
  return CRITERION_LABELS[code] || code;
}

// Типовий набір критеріїв для першого запуску сторінки /admin/weights, коли
// для обраного рівня ще немає активного профілю ваг (GET /v1/weights/active
// повертає 404) -- бекенд не має окремого ендпоінта "список критеріїв".
// Рівень 1 -- критерії ранжування заявників (черга) за статтею: s, g, f, q.
// Рівень 2 (розподіл кімнат) з інтерфейсу прибрано: у моделі статті кімнату
// обирають жорсткі й м'які обмеження, а не ваги.
export const DEFAULT_CRITERIA_BY_LEVEL = {
  1: [
    { code: "ses", label: CRITERION_LABELS.ses },
    { code: "dorm", label: CRITERION_LABELS.dorm },
    { code: "act", label: CRITERION_LABELS.act },
    { code: "zone", label: CRITERION_LABELS.zone },
  ],
};

export function criteriaFromWeights(weights) {
  return Object.keys(weights).map((code) => ({
    code,
    label: criterionLabel(code),
  }));
}
